import React from 'react';
import { IconProps } from '../../../../assets/icons/types';

const OrderPreparingIcon = ({ className, color }: IconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.3822 1H1.93945V2.51096H14.3822V1Z"
        stroke={color ?? 'current-color'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3864 6.53308H0.9375L1.93648 2.51172H14.3874L15.3864 6.53308Z"
        stroke={color ?? 'current-color'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.54786 7.68148C4.54786 8.65707 3.73975 9.44626 2.74075 9.44626C1.74175 9.44626 0.933594 8.65707 0.933594 7.68148V6.52344"
        stroke={color ?? 'current-color'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16114 7.68945C8.16114 8.66505 7.35298 9.45423 6.35398 9.45423C5.35499 9.45423 4.54688 8.66505 4.54688 7.68945"
        stroke={color ?? 'current-color'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7705 7.68945C11.7705 8.66505 10.9624 9.45423 9.96336 9.45423C8.96436 9.45423 8.15625 8.66505 8.15625 7.68945"
        stroke={color ?? 'current-color'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3877 6.52344V7.68148C15.3877 8.65707 14.5795 9.44626 13.5805 9.44626C12.5815 9.44626 11.7734 8.65707 11.7734 7.68148"
        stroke={color ?? 'current-color'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4033 9.25781V15.2422H1.91992V9.25781"
        stroke={color ?? 'current-color'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.51352 11.2598C6.55718 11.2598 7.40594 12.0886 7.40594 13.1078V15.2414H3.62109V13.1078C3.62109 12.0886 4.46985 11.2598 5.51352 11.2598Z"
        stroke={color ?? 'current-color'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default OrderPreparingIcon;
